import { render, staticRenderFns } from "./trainingRoom.vue?vue&type=template&id=73dbc724&scoped=true"
import script from "./trainingRoom.vue?vue&type=script&lang=js"
export * from "./trainingRoom.vue?vue&type=script&lang=js"
import style0 from "./trainingRoom.vue?vue&type=style&index=0&id=73dbc724&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dbc724",
  null
  
)

export default component.exports